RivalIQ.apps.AdsInsights.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    const FacebookAdAccount = RivalIQ.views.ItemView.mixin({
        template: '#facebookAdAccountItemSettingsTemplate',
        behaviors: {
            Information: {
                behaviorClass: RivalIQ.behaviors.Information
            },
            AttributeBuilder: {
                behaviorClass: RivalIQ.behaviors.AttributeBuilder
            }
        },
        tagName: 'tr',
        ui: {
            checkbox: 'input[type="checkbox"]'
        },
        events: {
            'change @ui.checkbox': 'toggleAccount'
        },
        modelEvents: {
            'change:disabled': 'render'
        },
        toggleAccount: function () {
            const me = this;
            const isSelected = me.ui.checkbox.prop('checked');
            me.model.set('selected', isSelected);
        },
        templateHelpers: function () {
            const me = this;

            return {
                disabled: Boolean(me.model.get('disabled')),
                selected: Boolean(me.model.get('selected')),
                landscapeCount: _.size(me.model.get('landscapes')),
                cleanedId: me.model.get('id').replace('act_', '')
            };
        }
    });

    views.FacebookAdAccounts = RivalIQ.views.CompositeView.mixin({
        template: '#facebookAdAccountsListSettingsTemplate',
        behaviors: {
            Information: {
                behaviorClass: RivalIQ.behaviors.Information
            }
        },
        childView: FacebookAdAccount,
        childViewContainer: 'tbody',
        model: new Backbone.Model(),
        collection: new Backbone.Collection(),
        ui: {
            btnDone: 'button.x-done',
            adAccountCount: '.x-ad-account-count'
        },
        triggers: {
            'click @ui.btnDone': 'click:done'
        },
        collectionEvents: {
            'change:selected': 'onSelectionChange'
        },
        loadData: function () {
            const me = this;
            const props = {
                channel: RivalIQ.enums.channels.FACEBOOK,
                landscapeId: RivalIQ.state.landscape.id
            };
            const activeFacebookAdAccountIds = RivalIQ.state.landscape.get('activeFacebookAdAccounts');

            return RivalIQ.data.privateMetadata.fetch(props)
                .then(function (metadata) {
                    const facebookAdAccounts = me.addLandscapesToAdAccounts(_.get(metadata, 'facebookAdAccounts'));
                    me.addInfoToAdAccounts(facebookAdAccounts);
                    me.collection.set(facebookAdAccounts, {
                        silent: true
                    });
                    _.each(activeFacebookAdAccountIds, function (id) {
                        const model = me.collection.get(id);
                        if (model) {
                            model.set('selected', true, {
                                silent: true
                            });
                        }
                    });
                });
        },

        checkAdAccountLimit: function () {
            const me = this;
            if (me.isAtAdAccountLimit()) {
                // If we're at the limit the already selected ad accounts can still be selected
                // but everything else must be disabled
                const activeAdAccountIds = me.getDistinctActiveAdAccountIds();
                me.collection.each(function (model) {
                    if (!_.includes(activeAdAccountIds, model.id) && !model.get('selected')) {
                        model.set({
                            disabled: true
                        });
                    }
                });
            } else {
                // If we're not at the limit, clear any disabled items
                me.collection.each(function (model) {
                    if (model.get('disabled')) {
                        model.set({
                            disabled: false
                        });
                    }
                });
            }
        },

        isAtAdAccountLimit: function () {
            const me = this;

            const maxFbAdAccounts = RivalIQ.state.account.get('plan').max_fb_ad_accounts;
            return _.size(me.getDistinctActiveAdAccountIds()) >= maxFbAdAccounts;
        },

        onRender: function () {
            const me = this;

            me.showAdAccountCount();
            me.checkAdAccountLimit();
        },

        getDistinctActiveAdAccountIds: function () {
            const me = this;

            let adAccountIds = _.reduce(RivalIQ.state.user.get('landscapes'), function (adAccountIds, landscape) {
                if (landscape.id !== RivalIQ.state.landscape.id) {
                    adAccountIds = adAccountIds.concat(_.get(landscape, ['settings', 'activeFacebookAdAccounts'], []));
                }
                return adAccountIds;
            }, []);

            adAccountIds = adAccountIds.concat(_.map(me.collection.where({
                selected: true
            }), 'id'));

            // only count accessible ad accounts
            adAccountIds = _.intersection(me.collection.pluck('id'), adAccountIds);

            return _.uniq(adAccountIds);
        },

        addLandscapesToAdAccounts: function (facebookAdAccounts) {
            // clone before mutating...
            facebookAdAccounts = _.cloneDeep(facebookAdAccounts);

            facebookAdAccounts = _.sortBy(facebookAdAccounts, 'name');

            _.each(RivalIQ.state.user.get('landscapes'), function (landscape) {
                if (landscape.id !== RivalIQ.state.landscape.id) {

                    const activeFacebookAdAccounts = _.get(landscape, ['settings', 'activeFacebookAdAccounts']);

                    _.each(activeFacebookAdAccounts, function (adAccountId) {
                        const facebookAdAccount = _.find(facebookAdAccounts, {
                            id: adAccountId
                        });
                        if (facebookAdAccount) {
                            facebookAdAccount.landscapes = facebookAdAccount.landscapes || [];
                            facebookAdAccount.landscapes.push(landscape.name);
                        }
                    });
                }
            });

            return facebookAdAccounts;
        },

        addInfoToAdAccounts: function (facebookAdAccounts) {
            _.each(facebookAdAccounts, function (facebookAdAccount) {
                const landscapes = facebookAdAccount.landscapes || [];
                facebookAdAccount.information = {
                    title: 'Landscapes',
                    content: landscapes.join('<br/>')
                };
            });
        },

        showAdAccountCount: function () {
            const me = this;

            const count = _.size(me.getDistinctActiveAdAccountIds());
            me.ui.adAccountCount.text(count);
        },

        onSelectionChange: function () {
            const me = this;
            const ids = _.map(me.collection.where({
                selected: true
            }), 'id');
            RivalIQ.state.landscape.set('activeFacebookAdAccounts', ids);
            me.showAdAccountCount();
            me.checkAdAccountLimit();
        },

        templateHelpers: function () {
            const me = this;
            return {
                adAccountMax: RivalIQ.state.account.get('plan').max_fb_ad_accounts,
                showFooter: Boolean(me.options.showFooter)
            };
        }

    });

});
